import axios from 'axios';
import { appConfig } from '../config/app';

// Create axios instance
const api = axios.create({
  baseURL: appConfig.api.baseURL,
  timeout: appConfig.api.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(appConfig.storage.token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem(appConfig.storage.token);
      localStorage.removeItem(appConfig.storage.user);
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

// API methods
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  validateOtp: (data) => api.post('/auth/validate-otp', data),
};

export const userAPI = {
  getUsers: () => api.get('/users'),
  createUser: (data) => api.post('/users', data),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`),
  getUserById: (id) => api.get(`/users/${id}`),
};

export const podAPI = {
  createPod: (data) => api.post('/pods', data),
  getPodsByStore: (storeId) => api.get(`/pods/store/${storeId}`),
  getPodById: (podId) => api.get(`/pods/${podId}`),
  updatePod: (podId, data) => api.post(`/pods/${podId}/update`, data),
  deletePod: (podId) => api.post(`/pods/${podId}/delete`),
  checkPointInPods: (storeId, data) => api.post(`/pods/store/${storeId}/check`, data),
  createDefaultPodsForAllStores: () => api.post('/pods/create-default-for-all'),
  createDefaultPodForStore: (storeId) => api.post(`/pods/store/${storeId}/create-default`),
  getAllPods: (activeOnly = true) => api.get(`/pods/all?activeOnly=${activeOnly}`),
  generatePolygonFromTravelDistance: (data) => api.post('/pods/generate-polygon', data),
  calculateTravelDistance: (data) => api.post('/pods/calculate-travel-distance', data),
};

export const stockAPI = {
  getBranchStock: (storeId) => api.get(`/stock/${storeId}`),
  upsertStock: (data) => api.post('/stock', data),
};

export default api; 